export type CardType =
  | 'visa'
  | 'mastercard'
  | 'amex'
  | 'diners'
  | 'discover'
  | 'jcb'
  | 'unionpay';

export const cardTypeIcons: Record<CardType, string> = {
  visa: require('assets/icons/payments-light/visa.png'),
  mastercard: require('assets/icons/payments-light/mastercard.png'),
  amex: require('assets/icons/payments-light/amex.png'),
  diners: require('assets/icons/payments-light/diners.png'),
  discover: require('assets/icons/payments-light/discover.png'),
  jcb: require('assets/icons/payments-light/jcb.png'),
  unionpay: require('assets/icons/payments-light/unionpay.png'),
};

export function getCardType(cardNumber: string): CardType | null {
  if (!cardNumber) return null;
  const numberStripped = cardNumber.replace(/\s+/g, '');
  const cards: Record<CardType, RegExp> = {
    visa: /^4[0-9]{12}(?:[0-9]{3})?/,
    mastercard: /^5[1-5][0-9]{14}/,
    amex: /^3[47][0-9]{13}/,
    diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
    discover: /^6(?:011|5[0-9]{2})[0-9]{12}/,
    jcb: /^(?:2131|1800|35\d{3})\d{11}/,
    unionpay: /^(62[0-9]{14,17})$/,
  };
  for (const card in cards) {
    if (cards[card as CardType].test(numberStripped)) {
      return card as CardType;
    }
  }
  return null;
}

export function getCardTypeIcon(type: CardType): string {
  return cardTypeIcons[type] ? cardTypeIcons[type] : '';
}
